<template>
  <div>
    <el-table :data="messageList">
      <el-table-column prop="modeName" label="名称">
      </el-table-column>
      <el-table-column prop="modeContent" label="内容" width="200px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createdTime | moment}}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          <span>{{scope.row.updateTime | moment}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
      </el-table-column>
    </el-table>
    <pagination :size="pagination.size" :page="pagination.page" :total="totalCount" @pageChanged="handleCurrentChange">
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })" v-model="editingMessage"></detail>
    <send v-model="sendingMessage"></send>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'MessageList',
  data() {
    return {
      editingMessage: null,
      sendingMessage: null
    };
  },
  computed: {
    ...mapState('messageTasks', ['totalCount', 'pagination']),
    ...mapGetters('messageTasks', ['taskList'])
  },
  components: {
    Pagination
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped>
</style>
